import { Artist } from "./artist.ts";
import Listing from "./listing.ts";

export interface EventArtistInterface {
    id: number | null;
    documentId: string | null;
    title: string | null;
    createdAt: string | null;
    updatedAt: string | null;
    publishedAt: string | null;
    time: string | null;
    lastSeen: string | null;
    artist: Artist | null;
    danceable: boolean | null;
    listing: Listing | null;
}

export class EventArtist implements EventArtistInterface {
    artist: Artist | null;
    id: number | null ;
    documentId: string;
    title: string | null;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    time: string | null;
    lastSeen: string | null;
    listing: Listing | null;
    danceable: boolean | null;
   

    constructor(params: Partial<EventArtistInterface> = {}) {
        this.id = params.id ?? 0;
        this.documentId = params.documentId ?? "";
        this.title = params.title ?? null;
        this.createdAt = params.createdAt ?? "";
        this.updatedAt = params.updatedAt ?? "";
        this.publishedAt = params.publishedAt ?? "";
        this.time = params.time ?? null;
        this.lastSeen = params.lastSeen ?? null;
        this.danceable = params.danceable ?? null;
        this.artist = params.artist ?? new Artist();
        this.listing = params.listing ?? Listing.active;
    }
}